import { useIsMobile } from "@/hooks/use-mobile";

const MONTHS = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

function daysInMonth(month: number, year: number) {
  if (!month || !year) return 31;
  return new Date(year, month, 0).getDate();
}

interface DobPickerProps {
  value: string;
  onChange: (value: string) => void;
}

const selectBaseStyle: React.CSSProperties = {
  WebkitAppearance: "menulist",
  appearance: "auto",
};

const DobPicker = ({ value, onChange }: DobPickerProps) => {
  const parts = value ? value.split("-") : ["", "", ""];
  const year = parts[0] && parts[0] !== "0000" ? parts[0] : "";
  const month = parts[1] ? String(parseInt(parts[1]) || "") : "";
  const day = parts[2] ? String(parseInt(parts[2]) || "") : "";
  const isMobile = useIsMobile();

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 80 }, (_, i) => currentYear - i);
  const monthNum = parseInt(month) || 0;
  const yearNum = parseInt(year) || currentYear;
  const maxDay = daysInMonth(monthNum, yearNum);
  const days = Array.from({ length: maxDay }, (_, i) => i + 1);

  const update = (d: string, m: string, y: string) => {
    if (d && m && y) {
      const maxD = daysInMonth(parseInt(m), parseInt(y));
      const clampedDay = Math.min(parseInt(d), maxD);
      onChange(`${y}-${m.padStart(2, "0")}-${String(clampedDay).padStart(2, "0")}`);
    } else if (!d && !m && !y) {
      onChange("");
    } else {
      const yy = y || "0000";
      const mm = m ? m.padStart(2, "0") : "00";
      const dd = d ? d.padStart(2, "0") : "00";
      onChange(`${yy}-${mm}-${dd}`);
    }
  };

  const selectClass = "w-full bg-muted rounded-2xl px-4 py-3 text-sm font-medium text-foreground outline-none cursor-pointer min-h-[48px]";

  return (
    <div className={`flex ${isMobile ? "flex-col" : "flex-row items-center"} gap-2`}>
      {/* Jour */}
      <div className="relative flex-1 min-w-0">
        <select
          value={day}
          onChange={(e) => update(e.target.value, month, year)}
          className={selectClass}
          style={selectBaseStyle}
          aria-label="Jour"
        >
          <option value="">Jour</option>
          {days.map((d) => (
            <option key={d} value={String(d)}>{d}</option>
          ))}
        </select>
      </div>

      {/* Mois */}
      <div className="relative flex-1 min-w-0">
        <select
          value={month}
          onChange={(e) => update(day, e.target.value, year)}
          className={selectClass}
          style={selectBaseStyle}
          aria-label="Mois"
        >
          <option value="">Mois</option>
          {MONTHS.map((m, i) => (
            <option key={i} value={String(i + 1)}>{m}</option>
          ))}
        </select>
      </div>

      {/* Année */}
      <div className="relative flex-1 min-w-0">
        <select
          value={year}
          onChange={(e) => update(day, month, e.target.value)}
          className={selectClass}
          style={selectBaseStyle}
          aria-label="Année"
        >
          <option value="">Année</option>
          {years.map((y) => (
            <option key={y} value={String(y)}>{y}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DobPicker;
